import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import logo from './christee-logo.png';

// changed name to avoid conflict with other components
const s = StyleSheet.create({
  logo: {
    width: 80,
    height: 15,
    position: 'absolute',
    bottom: 11,
    left: 65,
  },
  power: {
    fontSize: 9,
    position: 'absolute',
    bottom: 13,
    left: 10,
  },
});

const PoweredBy = () => (
  <View>
    <Text style={s.power}>Powered By</Text>
    <Image style={s.logo} src={logo} />
  </View>
);

export default PoweredBy;
